import React from 'react'

import {Grid} from "@material-ui/core";

import InfoCard from "../../DynamicStep/components/InfoCard";
import SafeHtml from "../../../../../../../../components/SafeHtml";

import useStyles from './styles'

const BankHint = ({classes, bankName, isBankOnline}) => (
  isBankOnline ? (
    <>
      <span>
        Bei Nutzung der elektronischen Unterschrift für die Aufträge an die {bankName} werden diese nach Unterzeichnung und Bestätigung durch die Kundin/den Kunden direkt an die Depotstelle übermittelt. Eine zusätzliche Übermittlung dieser Formulare per Post, E-Mail oder Fax ist dann nicht mehr erforderlich.
      </span>
      <br/>
      <span className={classes.italicText}>
        Alle zusätzlichen Formulare, aus dem Formularcenter, müssen vorerst auf gewohntem Wege an die jeweilige Depotstelle gesendet werden.
      </span>
    </>
  ) : (
    <>
      <span>
        Bei Nutzung der elektronischen Unterschrift für die Aufträge an die {bankName} werden diese nach Unterzeichnung und Bestätigung durch die Kundin/den Kunden noch nicht an die Depotstelle übermittelt.
      </span>
      <br/>
      <span>
        Bitte beachten Sie, dass Sie alle Formulare, zur erfolgreichen Umsetzung per E-Mail, Post oder Fax an die Depotstelle weiterreichen müssen.
      </span>
    </>
  )
);

const BanksHint = props => {
  const {
    bankName,
    isBankOnline,
    additionalBankText,
    newDesign,
    isIndividualAssetManagement,
  } = props;

  const classes = useStyles();

  if(newDesign || isIndividualAssetManagement){
    return (
      <InfoCard isNewDesign>
        <Grid container spacing={3}>
          {!isIndividualAssetManagement && (
            <Grid item xs={12}>
              <BankHint classes={classes} bankName={bankName} isBankOnline={isBankOnline} />
            </Grid>
          )}
          {!!additionalBankText && (
            <Grid item xs={12}><AdditionalBankText additionalBankText={additionalBankText} /></Grid>
          )}
        </Grid>
      </InfoCard>
    )
  }
  
  return (
    <Grid container spacing={3}>
      {!isIndividualAssetManagement && (
        <Grid item xs={12} className={classes.bankInfo}>
          <BankHint classes={classes} bankName={bankName} isBankOnline={isBankOnline} />
        </Grid>
      )}
      {!!additionalBankText && (
        <Grid item xs={12} className={classes.bankInfo}>
          <AdditionalBankText additionalBankText={additionalBankText} />
        </Grid>
      )}
    </Grid>
  )
};
  
export default BanksHint;

const AdditionalBankText = ({additionalBankText}) => <SafeHtml html={additionalBankText} allowed_attrs={['href', 'target']} allowed_tags={['a']} />
  